import { onErrorCaptured, ref } from "vue";
import { capturePurchasingException } from '@client/monolith/core/plugins/sentry/helper';

export type CaptureErrorFunc = (msgDetail: string, error: Error, componentName: string) => void;

export const useErrorLogger = ({ editorId }: { editorId: string }) => {
    // Should contain the latest version of the editor content, to be used for debugging purposes
    const lastContentSnapshot = ref<string | null>(null);

    const takeContentSnapshot = (content: string) => {
        lastContentSnapshot.value = content;
    };

    const captureError = (msgDetail: string, error: Error, componentName: string = 'UnknownComponent') => {
        const msg = `[rich-text-editor-wrapper][${editorId}][${componentName}] Error captured from inside rich-text-editor instance`;

        capturePurchasingException(
            new Error(msg, { cause: error }),
            [
                { label: 'editorId', value: editorId },
                { label: 'msgDetail', value: msgDetail },
                { label: 'componentName', value: componentName },
                { label: 'lastContentSnapshot', value: lastContentSnapshot.value },
            ],
        );
    };


    onErrorCaptured((error, component) => captureError('Error unhandled by child component, captured at top-level via onErrorCaptured hook', error, component._?.type?.__name));

    return {
        takeContentSnapshot,
        captureError,
    };
};
